import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export const formatDate = (date) => {
	const d = new Date(date);
	const year = d.getFullYear();
	const month = String(d.getMonth() + 1).padStart(2, "0");
	const day = String(d.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

export function cn(...inputs) {
	return twMerge(clsx(inputs));
}
